var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import cxs from 'cxs/component';
import Theme, { marks, strMark } from 'Theme';
import History from 'helpers/History';
import { T } from 'helpers/i18n';
import { Button, FieldType, Input } from 'elements';
var UserLogin = /** @class */ (function (_super) {
    __extends(UserLogin, _super);
    function UserLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            client: '',
            username: '',
            password: '',
            hiddenFields: false
        };
        _this.handleChange = function (event) {
            // console.log('handleChange - event.target.name', event.target.name)
            var temp = {};
            temp[event.target.name] = event.target.value;
            _this.setState(temp);
        };
        _this.handleSubmit = function () {
            var data = {
                client: _this.state.client,
                username: _this.state.username,
                password: _this.state.password,
            };
            _this.props.store.users.login(data).then(function () { return History.replace('/'); });
        };
        _this.handleHelp = function () {
            /* History.replace('/recovery')*/
        };
        return _this;
    }
    UserLogin.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b;
        if (prevProps !== this.props) {
            var client = (_a = this.props.queryParams) === null || _a === void 0 ? void 0 : _a.client;
            var username = (_b = this.props.queryParams) === null || _b === void 0 ? void 0 : _b.username;
            if (client && username) {
                this.setState({
                    client: client,
                    username: username,
                    hiddenFields: true
                });
            }
        }
    };
    UserLogin.prototype.render = function () {
        var _this = this;
        var _a;
        var isCivitrip = ((_a = this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
        var _b = this.state, client = _b.client, username = _b.username, password = _b.password;
        return (React.createElement(Wrapper, null,
            React.createElement(InsideWrapper, null,
                !this.state.hiddenFields && React.createElement(StyledInput, { label: T('client'), name: 'client', value: client, type: FieldType.Text, onChange: this.handleChange }),
                React.createElement(StyledInput, { label: T('username'), name: 'username', value: username, type: FieldType.Text, 
                    // disabled={isCivitrip}
                    onChange: function (e) {
                        // if (!isCivitrip) {
                        _this.handleChange(e);
                        // }
                    } }),
                React.createElement(StyledInput, { label: T('password'), name: 'password', value: password, type: FieldType.Password, onChange: this.handleChange, onSubmit: this.handleSubmit })),
            React.createElement(ButtonWrapper, null,
                React.createElement(RecoveryButton, { onClick: this.handleHelp }, T('help')),
                React.createElement(LoginButton, { primary: !isCivitrip, iscivitrip: isCivitrip, loading: 'post@login/', onClick: this.handleSubmit }, T('logIn')))));
    };
    UserLogin = __decorate([
        inject('store'),
        observer
    ], UserLogin);
    return UserLogin;
}(Component));
export default UserLogin;
var Wrapper = cxs('div')({});
var InsideWrapper = cxs('div')({
    padding: Theme.size.space[4]
});
var ButtonWrapper = cxs('div')({
    borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    marginTop: Theme.size.space[1]
});
var StyledInput = cxs(Input)({
    padding: Theme.size.space[1]
});
var RecoveryButton = cxs(Button)({
    width: '50%',
    borderRight: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    padding: Theme.size.space[2]
});
var LoginButton = cxs(Button)(function (_a) {
    var iscivitrip = _a.iscivitrip;
    return (__assign(__assign({ width: '50%', padding: Theme.size.space[2], color: Theme.color.primary }, iscivitrip ? { backgroundColor: Theme.color.civitrip.primary, color: 'white' } : undefined), { ':hover': __assign({}, iscivitrip ? { backgroundColor: 'white', color: Theme.color.civitrip.primary } : undefined) }));
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/containers/UserLogin.tsx
// module id = 1629
// module chunks = 0